var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"details"},[_c('h3',[_vm._v(_vm._s(_vm.advice.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.advice.content)}},[_vm._v("  "+_vm._s(_vm.advice.content))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69503b4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advice.vue
// module id = null
// module chunks = 